import {Component, Input} from '@angular/core';


@Component({
    selector: 'app-resource-download-indicator',
    imports: [],
    templateUrl: './resource-download-indicator.component.html',
    styleUrls: ['./resource-download-indicator.component.css']
})
export class ResourceDownloadIndicatorComponent {

  @Input() set percent(percent: number) {
    this.privPercent = percent;
    if (this.privPercent > 0 && !this.showStarted) {
      this.startShow();
    }
    this.calculateRoundDraw();
  }

  @Input() radius = 10;
  roundDraw;
  privPercent;

  showStarted = false;
  show = false;

  startShow(): void {
    this.showStarted = true;
    setTimeout(() => {
      this.show = true;
    }, 1000);
  }

  calculateRoundDraw(): void {
    const roundCircum = 2 * this.radius * Math.PI;
    this.roundDraw = (this.privPercent * roundCircum / 100) + ' 999';
  }


}
